import { j as c } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as s } from "react";
import { I as r } from "../../../../IconBase-CxZyIWw2.js";
const t = s((a, i) => /* @__PURE__ */ c.jsx(
  r,
  {
    ref: i,
    ...a,
    image: (l) => /* @__PURE__ */ c.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...l,
        children: [
          /* @__PURE__ */ c.jsx("g", { clipPath: "url(#clip0_3410_69078)", children: /* @__PURE__ */ c.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M15.964 12.792c-.163.38-.851.659-2.105.854-.065.087-.118.459-.203.748-.051.174-.176.277-.38.277h-.009c-.293 0-.6-.135-1.214-.135-.828 0-1.114.189-1.758.644-.682.482-1.336.898-2.313.856-.989.073-1.813-.529-2.277-.857-.648-.457-.932-.643-1.758-.643-.59 0-.96.148-1.214.148-.252 0-.35-.154-.388-.283-.085-.287-.138-.664-.204-.754-.646-.1-2.103-.354-2.14-1.005a.33.33 0 0 1 .277-.345c2.174-.358 3.154-2.591 3.195-2.686l.007-.016q.174-.355.077-.586c-.158-.372-.84-.505-1.127-.619-.74-.292-.844-.629-.8-.86.076-.4.679-.647 1.031-.482.279.13.527.197.736.197a.64.64 0 0 0 .311-.068c-.064-1.123-.222-2.728.178-3.624 1.055-2.366 3.292-2.55 3.952-2.55L8.154 1c1.63 0 3.196.837 3.96 2.551.4.896.243 2.494.178 3.626.05.027.136.06.27.066q.3-.013.689-.195a.85.85 0 0 1 .64.002c.296.106.483.32.488.559q.007.458-.809.781a4 4 0 0 1-.232.08c-.306.096-.769.243-.894.539q-.098.23.076.586l.008.016c.04.095 1.02 2.327 3.195 2.685.2.033.348.247.241.496"
            }
          ) }),
          /* @__PURE__ */ c.jsx("defs", { children: /* @__PURE__ */ c.jsx("clipPath", { id: "clip0_3410_69078", children: /* @__PURE__ */ c.jsx("path", { fill: "#fff", d: "M0 0h16v16H0z" }) }) })
        ]
      }
    )
  }
));
t.displayName = "SnapchatIcon";
export {
  t as SnapchatIcon,
  t as default
};
//# sourceMappingURL=index.js.map
